"use client";

import { usePublicAuthState } from "@/components/auth/PublicAuthProvider";
import { Button } from "@/components/ui/button";
import Link from "@/lib/locale/Link";
import { useSignOut } from "@/lib/nhost/session-hooks";

type LandingNavAccountActionsProps = {
  dashboardLabel: string;
  signInLabel: string;
  signOutLabel: string;
  signUpLabel: string;
};

export function LandingNavAccountActions({
  dashboardLabel,
  signInLabel,
  signOutLabel,
  signUpLabel,
}: LandingNavAccountActionsProps) {
  const authState = usePublicAuthState();
  const { isLoading: isSigningOut, signOut } = useSignOut();

  const handleSignOut = async () => {
    await signOut();
    window.location.reload();
  };

  if (authState === "signed-in") {
    return (
      <div className="flex items-center gap-1 sm:gap-2">
        <Button asChild className="h-11 px-2 py-1 md:h-10 md:px-4 md:py-2">
          <Link href="/app/dashboard">{dashboardLabel}</Link>
        </Button>
        <Button
          variant="ghost"
          className="h-11 px-2 py-1 md:h-10 md:px-4 md:py-2"
          aria-busy={isSigningOut}
          disabled={isSigningOut}
          loading={isSigningOut}
          onClick={handleSignOut}
        >
          {signOutLabel}
        </Button>
      </div>
    );
  }

  if (authState === "loading") {
    return (
      <div aria-hidden="true" className="invisible space-x-4">
        <span>{signInLabel}</span>
        <Button asChild className="px-2 py-1 md:px-4 md:py-2">
          <span>{signUpLabel}</span>
        </Button>
      </div>
    );
  }

  return (
    <div className="space-x-4">
      <Link href="/app/auth/sign-in">{signInLabel}</Link>
      <Button asChild className="px-2 py-1 md:px-4 md:py-2">
        <Link href="/app/auth/sign-up">{signUpLabel}</Link>
      </Button>
    </div>
  );
}
